import { useBlockNoteEditor, useComponentsContext } from "@blocknote/react";
import type { Schema } from "blocks-schema";
import classNames from "classnames";
import { type FontFamily, FontFamilyValues } from "schemas";
import { BaseSelect, bgStyles, borderStyles, flexStyles, heightStyles, textStyles } from "ui";

export function SetFontStyleButton() {
  const editor = useBlockNoteEditor<
    typeof Schema.blockSchema,
    typeof Schema.inlineContentSchema,
    typeof Schema.styleSchema
  >();

  const Components = useComponentsContext();

  if (!Components) {
    return null;
  }
  const options = FontFamilyValues.map((value) => ({ label: value, value }));
  const optionsWithEmpty = [{ label: "Select font", value: null }, ...options];

  const onChange = (selection: { value: FontFamily | undefined | null } | null) => {
    if (selection === null || !selection.value) {
      editor.addStyles({ font: undefined });
    } else {
      editor.addStyles({ font: selection.value });
    }
  };

  return (
    <div
      className={classNames(
        heightStyles.height200,
        bgStyles.neutral200,
        textStyles.neutral600,
        flexStyles.horiz,
        flexStyles.justifyCenter,
        flexStyles.alignCenter,
        borderStyles.neutral400,
        borderStyles.radius025,
      )}
    >
      <BaseSelect
        raw
        options={optionsWithEmpty}
        onChange={onChange}
        value={editor.getActiveStyles().font as FontFamily}
      />
    </div>
  );
}
